<template>
  <div id="app">
    <async-component ref="component"/>
  </div>
</template>

<script>
import AsyncComponent from './components/AsyncComponent.vue'

export default {
  name: 'App',
  components: {
    AsyncComponent
  },
  created () {
    this.$danmaku.socketService.opened().then(() => {
      this.$danmaku.module.getModuleManifest().then(manifest => {
        Promise.all([this.$danmaku.module.fetchModuleData(), this.$danmaku.module.fetchModuleConfig()]).then(() => {
          if (manifest && manifest.browserView) {
            this.$refs.component.loadConfig({
              script: manifest.browserView.js,
              stylesheet: manifest.browserView.css,
              reloadNotice: manifest.browserView.reloadNotice || ''
            })
          }
        })
      })
    })
  }
}
</script>

<style lang="stylus">
*
  box-sizing border-box
html, body
  margin 0
  padding 0
</style>

<style lang="stylus" scoped>
#app
  height 100vh
  display flex
  flex-direction column
</style>



// WEBPACK FOOTER //
// src/App.vue